import {Component, OnInit} from '@angular/core';
import {HttpApiService} from "../../../../services/http-api.service";
import {EndpointsService} from "../../../../services/endpoints.service";

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent implements OnInit {
  notifications: Array<any> = [];
  selectedNotification: any;
  isLoading: boolean = false;
  pageNumber: number = 0;
  private loadMore: boolean = true;

  constructor(private api: HttpApiService,
              private endpoints: EndpointsService) {
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    console.log("load data : page " + this.pageNumber);
    if (!this.loadMore) {
      return;
    }
    this.isLoading = true;
    this.api.get(this.endpoints.getNotificationListUrl() + "?page=" + this.pageNumber, true)
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(response => {
        if (this.pageNumber === 0 && response.length > 0) {
          this.selectedNotification = response[0].notification;
          this.markAsRead(response[0]);
        }
        if (response.length === 0) {
          this.loadMore = false;
        }
        this.pageNumber++;
        this.notifications = this.notifications.concat(response);
      })
  }

  markAsRead(item) {
    if (!item.isRead) {
      this.api.put(this.endpoints.getMarkAsReadNotificationUrl() + "?notificationStatusId=" + item.id, {}, true)
        .subscribe(response => {
          item.isRead = true;
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/buyer/notifications/notifications-list/notifications-list.component.ts